import { readMeetingFromItem, subscribeToMeetingChanges } from './meetingOfficeService';
import type { MeetingInfo } from '../types/meeting';

export type MeetingService = {
  readonly read: () => Promise<MeetingInfo | null>;
  readonly subscribe: (onChange: () => void) => () => void;
};

export const officeMeetingService: MeetingService = {
  read: readMeetingFromItem,
  subscribe: subscribeToMeetingChanges,
};
